/* Sisters Moto: load the YouTube player only when a video is tapped (snippets/sm-video-embed.liquid). */
(function () {
  if (window.__smVideo) return;
  window.__smVideo = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.sm-video__play');
    if (!btn) return;
    var frame = btn.closest('[data-sm-yt]');
    if (!frame) return;
    var id = frame.getAttribute('data-sm-yt');
    if (!/^[\w-]{6,20}$/.test(id)) return;
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
    f.title = frame.getAttribute('data-sm-yt-title') || 'Video';
    f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    f.allowFullscreen = true;
    f.referrerPolicy = 'strict-origin-when-cross-origin';
    frame.innerHTML = '';
    frame.appendChild(f);
    f.focus();
  });
})();
